if(instagram_enable) {
    if (typeof(instagram_id) != 'undefined' ) {

        if ($('.instagram-block-footer #instafeed').length) {
            var instaContainer = $('.instagram-block-footer #instafeed'),
                instaTpl = instaContainer.find("template"),
                i = $(instaContainer.find("template")[0].content).children().html(),
                a = instaContainer.data("count"),
                s = {240: 1, 320: 2, 480: 3, 640: 4},
                l = instaContainer.data("srcimg-size"),
                o = {};
            $.instagramFeed({
                'username': instagram_id,
                'container': instaContainer,
                'display_profile': false,
                'display_biography': false,
                'display_gallery': true,
                'callback': null,
                'styling': true,
                'items': 6,
                'items_per_row': 6,
                'margin': 1,
                'get_data': !0,
                'callback': function (instaTpl) {
                    var o = instaTpl.edge_owner_to_timeline_media;
                    for (var r = 0; r < Math.min(a, o.edges.length); r++) {
                        var d = i.replace(/post-image/g, o.edges[r].node.thumbnail_resources[s[l]].src)
                            .replace(/post-link/g, "https://www.instagram.com/p/" + o.edges[r].node.shortcode)
                            .replace(/post-comments/g, o.edges[r].node.edge_media_to_comment.count)
                            .replace(/post-likes/g, o.edges[r].node.edge_liked_by.count);
                        instaContainer.html(instaContainer.html() + d)
                    }
                    $('#instafeed template').detach();
                }
            });
        }

        if ($('.instagram_section #instafeed').length) {
            var instaContainer = $('.instagram_section #instafeed'),
                instaTpl = instaContainer.find("template"),
                i = $(instaContainer.find("template")[0].content).children().html(),
                a = instaContainer.data("count"),
                s = {240: 1, 320: 2, 480: 3, 640: 4},
                l = instaContainer.data("srcimg-size"),
                o = {};
            $.instagramFeed({
                'username': instagram_id,
                'container': instaContainer,
                'display_profile': false,
                'display_biography': false,
                'display_gallery': true,
                'callback': null,
                'styling': true,
                'items': 6,
                'items_per_row': 6,
                'margin': 1,
                'get_data': !0,
                'callback': function (instaTpl) {
                    var o = instaTpl.edge_owner_to_timeline_media;
                    for (var r = 0; r < Math.min(a, o.edges.length); r++) {
                        var d = i.replace(/post-image/g, o.edges[r].node.thumbnail_resources[s[l]].src)
                            .replace(/post-link/g, "https://www.instagram.com/p/" + o.edges[r].node.shortcode)
                            .replace(/post-comments/g, o.edges[r].node.edge_media_to_comment.count)
                            .replace(/post-likes/g, o.edges[r].node.edge_liked_by.count);
                        instaContainer.html(instaContainer.html() + d)
                    }
                    $('#instafeed template').detach();
                }
            });
        }
    }
}